import { z } from 'zod';

/** The code GraphQL (`extensions.code`) and mesh-client (403 body `code`) refuse a blocked team with. */
export const TEAM_BLOCKED = 'TEAM_BLOCKED';

/** Window event `ConnectedClientProvider` listens for to recheck the Viewer. */
export const TEAM_BLOCKED_EVENT = 'team-blocked';

const TeamBlockedBodySchema = z.object({ code: z.literal(TEAM_BLOCKED) });

export const isTeamBlockedResponse = (status: number, body: unknown) =>
  status === 403 && TeamBlockedBodySchema.safeParse(body).success;

// The server also refuses data owned by another blocked team, so a refusal alone doesn't mean the connected team is blocked.
export function notifyTeamBlocked() {
  window.dispatchEvent(new Event(TEAM_BLOCKED_EVENT));
}
